import React, { useState, useEffect } from "react";
import { FaPhone } from "react-icons/fa";
import { preparePhoneInput } from "../../../utils/miscUtils";

const PresentationDisplayInfoModal = ({ isOpen, onClose, onSubmit, type }) => {
  const [userPhone, setUserPhone] = useState("");

  useEffect(() => {
    if (isOpen) {
      const savedPhone = localStorage.getItem("userInfoPhone");
      if (savedPhone) setUserPhone(savedPhone);
    }
  }, [isOpen]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    onSubmit(type, "", userPhone);
  };

  const handlePhoneChange = (e) => {
    const next = preparePhoneInput(e.target.value);
    setUserPhone(next);
    localStorage.setItem("userInfoPhone", next);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl w-[480px] shadow-lg">
        <h2 className="text-2xl font-bold mb-6 text-gray-800">
          Enter Your Phone Number
        </h2>
        <div className="mb-8">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <FaPhone className="text-gray-400 text-xl" />
            </div>
            <input
              id="phone"
              placeholder="Enter phone number"
              inputMode="tel"
              maxLength={30}
              className="w-full pl-10 p-3 border border-gray-300 text-gray-700 rounded-xl text-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={userPhone}
              onChange={handlePhoneChange}
              onKeyDown={handleKeyPress}
              autoFocus
            />
          </div>
        </div>
        <div className="flex justify-end space-x-4">
          <button
            className="px-6 py-3 bg-gray-500 text-white rounded-xl text-xl hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-6 py-3 bg-blue-600 text-white rounded-xl text-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleSubmit}
            disabled={!userPhone}
          >
            Start {type === "call" ? "Call" : "Text"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PresentationDisplayInfoModal;
